import { render } from "./destinationCreate.vue?vue&type=template&id=902f9b14&scoped=true"
import script from "./destinationCreate.vue?vue&type=script&lang=js"
export * from "./destinationCreate.vue?vue&type=script&lang=js"

import "./destinationCreate.vue?vue&type=style&index=0&id=902f9b14&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src802653185/src/macra-logistics-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-902f9b14"]])

export default __exports__